// Define types for Clerk's unsafeMetadata for our app
import type { useUser } from '@clerk/nextjs';
import getConfig from 'next/config';

// Infer the return type of the useUser hook
type UseUserReturn = ReturnType<typeof useUser>;

// Extract the type of the 'user' property from the return type
type UserResourceType = UseUserReturn['user'];

const { BYPASS_CLERK } = getConfig().publicRuntimeConfig;

export const shouldBypassClerk = () => BYPASS_CLERK;

export interface ClerkUserMetadata {
  birthdate?: string;
  accepted_terms_at?: string;
  tcpa_accepted_at?: string;
  analytics_uuid?: string;
  initial_anonymous_id?: string;
}

// Helper functions to safely get typed values from Clerk's metadata
export function getMetadataString(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined;
}

export function getUserMetadata(metadata: Record<string, unknown> | null | undefined): ClerkUserMetadata {
  if (!metadata) return {};

  return {
    birthdate: getMetadataString(metadata.birthdate),
    accepted_terms_at: getMetadataString(metadata.accepted_terms_at),
    tcpa_accepted_at: getMetadataString(metadata.tcpa_accepted_at),
    analytics_uuid: getMetadataString(metadata.analytics_uuid),
    initial_anonymous_id: getMetadataString(metadata.initial_anonymous_id),
  };
}

export function isAccountCompleted(user: UserResourceType, metadata: ClerkUserMetadata): boolean {
  return (
    !!user &&
    !!user.firstName &&
    !!user.lastName &&
    !!user.primaryPhoneNumber &&
    !!user.primaryEmailAddress &&
    !!user.primaryPhoneNumber.verification &&
    user.primaryPhoneNumber.verification.status === 'verified' &&
    !!metadata.birthdate &&
    !!metadata.accepted_terms_at
  );
}
